export default __webpack_public_path__ + "static/media/access.964d6119.svg";